package org.example.site_web

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.ColorPalette
import com.varabyte.kobweb.silk.theme.colors.ColorPalettes
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */

class BrandPalette(
    val darkBackColor: Color,
    val farBackColor:Color,
    val mainPalette: TrioColor,
    val comPalette: TrioColor,
    val optPalette: DuoColor
    ){
    class TrioColor(
        val primary : Color,
        val darker : Color,
        val darkest : Color,
    )
    class DuoColor(
        val primary : Color,
        val comp : Color
    )
}

val aiPalette = BrandPalette(
    darkBackColor = Color.rgb(0x191F39),
    farBackColor = Color.rgb(0x2A2D45),
    mainPalette = BrandPalette.TrioColor(
        primary = Color.rgb(0xDD1263),
        darker = Color.rgb(0xA21874),
        darkest = Color.rgb(0x702283),
    ),
    comPalette = BrandPalette.TrioColor(
        primary = Color.rgb(0x13DE1F),
        darker = Color.rgb(0x2AA318),
        darkest = Color.rgb(0xB4D780),
    ),
    optPalette = BrandPalette.DuoColor(
        primary = Color.rgb(0x9EA3B8),
        comp = Color.rgb(0xF3C2FF),
    )
)


class SitePalette(
    val nearBackground: Color,
    val farBackground: Color,
    val cobweb: Color,
    val brand: Brand,
) {
    class Brand(
        val primary: Color = Colors.GoldenRod,
        val accent: Color = Color.rgb(0xFFEFB3),
        val accent2: Color = Color.rgb(0x702283),
    )
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = aiPalette.darkBackColor,
        farBackground = aiPalette.farBackColor,
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(
            primary = aiPalette.mainPalette.primary,
            accent = Color.rgb(0x697565),
            accent2 = aiPalette.mainPalette.darkest,
        )
    )
    val dark = SitePalette(
        nearBackground = aiPalette.darkBackColor,
        farBackground = aiPalette.farBackColor,
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(
            primary = aiPalette.mainPalette.primary,
            accent = Color.rgb(0x697565),
            accent2 = aiPalette.mainPalette.darkest,
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Colors.Red//Color.rgb(0x3C3D37)
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = aiPalette.darkBackColor
    ctx.theme.palettes.dark.color = Colors.White
}
